import type { OptimizationMetric, UserPlan, Workbench } from '@minglun/domain';

export const needsReference = (metric: OptimizationMetric) => metric.requiresBaseValue && metric.id !== 'metric.global.element-resilience' && metric.id !== 'metric.fate-value';
export interface PlanIssue { section: 'objectives' | 'base' | 'resources'; label: string; inputLabel: string }
export function planIssues(workbench: Workbench, plan: UserPlan): PlanIssue[] {
  const issues: PlanIssue[] = [];
  if (!plan.objectives.some(item => Number.isFinite(item.weight) && item.weight > 0)) {
    issues.push({ section: 'objectives', label: '至少将一项重视程度设为大于 0', inputLabel: `${workbench.optimizationMetrics.find(m => m.id !== 'metric.global.element-resilience')?.name ?? ''}权重数值` });
  }
  const values = new Map(plan.baseAttributes.map(item => [item.metricId, item.value]));
  for (const metric of workbench.optimizationMetrics.filter(needsReference)) {
    const value = values.get(metric.id);
    if (value === undefined || !Number.isFinite(value) || value <= 0) issues.push({ section: 'base', label: `请填写${metric.name}参考值（大于 0）`, inputLabel: `${metric.name}参考基础属性` });
  }
  return issues;
}
